import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import Tweet from '../components/Tweet'; // if you have a Tweet component; otherwise create a simple display
import { formatDistanceToNow } from 'date-fns';

const PostPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getAuthHeaders } = useContext(AuthContext);
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const headers = getAuthHeaders();
        console.log('Fetching post', id);
        const res = await fetch(`/api/posts/${id}`, { headers });
        console.log('Post response status:', res.status);
        const data = await res.json();
        console.log('Post data:', data);
        if (data.success && data.post) {
          setPost(data.post);
        } else {
          setError('Post not found');
        }
      } catch (err) {
        console.error('Fetch post error:', err);
        setError(err.message);
      }
    };

    const fetchComments = async () => {
      try {
        const headers = getAuthHeaders();
        const res = await fetch(`/api/posts/${id}/comments`, { headers });
        const data = await res.json();
        if (data.success) {
          setComments(data.comments);
        }
      } catch (err) {
        console.error('Failed to fetch comments', err);
      }
    };

    Promise.all([fetchPost(), fetchComments()]).finally(() => setLoading(false));
  }, [id, getAuthHeaders]);

  if (loading) return <div className="loading">Loading post...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!post) return <div className="error">Post not found</div>;

  return (
    <div className="post-page" style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      <button onClick={() => navigate(-1)} style={{ marginBottom: '20px', background: 'transparent', border: 'none', color: 'var(--gold)', cursor: 'pointer' }}>
        ← Back
      </button>

      {/* Main post */}
      <div className="post-container" style={{ borderBottom: '2px solid var(--gold)', paddingBottom: '20px', marginBottom: '20px' }}>
        <Tweet tweet={post} />
      </div>

      {/* Comments section */}
      <h3 style={{ color: 'var(--gold)' }}>Comments</h3>
      {comments.length === 0 ? (
        <p style={{ color: 'var(--text-secondary)' }}>No comments yet.</p>
      ) : (
        comments.map(comment => (
          <div key={comment.id} style={{ marginBottom: '15px', padding: '10px', borderLeft: '2px solid var(--gold)' }}>
            <Tweet tweet={comment} />
          </div>
        ))
      )}
    </div>
  );
};

export default PostPage;
